import { render, staticRenderFns } from "./NavMain.vue?vue&type=template&id=58cf3aa4&scoped=true"
import script from "./NavMain.vue?vue&type=script&lang=js"
export * from "./NavMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf3aa4",
  null
  
)

export default component.exports